export default __webpack_public_path__ + "static/media/fg.1aff9f5e.png";